import {useRouter} from 'next/router';
import {useEffect, useState} from 'react';
import {TrackEventFetcherHeadless} from '../../domain/content/[seriesId]/viewer/[productId]/headless/TrackEventFetcherHeadless';
import {TrackEventObject} from '../../logging/TrackEventObject.interface';
import {currentEventContext} from '../../logging/variables';
import {usePrevious} from '../shared/hooks/usePrevious';
import {IS_CLIENT_SIDE} from '../shared/utils/constants';

export function TrackPageViewContainer({
  customPropsDataKeyList = [],
  trackObj,
  sendTrackEvent = true,
  resendLogOnVisibilityChange = false,
}: {
  trackObj: TrackEventObject;
  customPropsDataKeyList?: string[];
  sendTrackEvent?: boolean;
  resendLogOnVisibilityChange?: boolean;
}) {
  // currentPageView 는 trackEvent() 내에서도 세팅하지만 일반적으로 PV 는 useEffect 에서 남기기때문에 viewImpression 과 타이밍이 겹칠 수 있습니다. 그래서 랜더링 시점에 먼저 currentPageView 를 세팅합니다
  if (IS_CLIENT_SIDE && trackObj.actionType === 'Pageview') {
    currentEventContext.currentPageView = trackObj;
  }
  const [updatedObj, setUpdatedObj] = useState<TrackEventObject | undefined>(
    undefined
  );
  const router = useRouter();
  // pageview 는 URL 변경도 트래킹 합니다
  const prevUrl = usePrevious(IS_CLIENT_SIDE ? router.asPath : undefined);
  useEffect(() => {
    // TEST 환경에선 없을 수 있음
    if (!router?.asPath) {
      return;
    }
    // 이전과 URL 이 다를때만 전송합니다. 만약 이 조건이 없다면 next.js 의 pages 가 리랜더링될 때 마다 전송되기 때문에 URL 기반으로 전송하도록 합니다
    if (prevUrl !== router.asPath && sendTrackEvent) {
      setUpdatedObj(mergeCustomProps(trackObj, customPropsDataKeyList));
    }
  }, [
    customPropsDataKeyList,
    trackObj,
    prevUrl,
    router.asPath,
    sendTrackEvent,
  ]);

  return updatedObj ? (
    <TrackEventFetcherHeadless
      obj={updatedObj}
      resendLogOnVisibilityChange={resendLogOnVisibilityChange}
    />
  ) : null;
}

function mergeCustomProps(
  trackObj: TrackEventObject,
  customPropsDataKeyList: string[]
) {
  if (!customPropsDataKeyList || customPropsDataKeyList.length <= 0) {
    return trackObj;
  }
  let result = trackObj;
  customPropsDataKeyList.forEach(dataKey => {
    const dataCustomPropsEl = document.querySelector(`[${dataKey}]`);
    if (dataCustomPropsEl && dataCustomPropsEl instanceof HTMLElement) {
      const dataCustomProps = dataCustomPropsEl.getAttribute(dataKey);
      if (!dataCustomProps) {
        return;
      }
      const [key, value] = dataCustomProps.split('=');
      result = {
        ...result,
        customProps: {...result.customProps, [key]: value},
      };
    }
  });
  return result;
}
